import {
  createStyles,
  makeStyles,
  TableCell,
  Theme,
  withStyles,
} from '@material-ui/core';

export const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  filter: {
    marginTop: '1%',
    marginBottom: '1%',
  },
  item: {
    paddingRight: '4%',
  },
  filterCard: {
    padding: 16,
    borderRadius: 12,
    marginTop: 16,
    marginBottom: 16,
    border: '1px solid rgba(0, 0, 0, 0.08)',
  },
  filterLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.6)',
    marginBottom: 4,
    display: 'block',
  },
  filterField: {
    width: '100%',
  },
});

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);
